
import moment from "moment";
import {PHOTO_PICKER_MODEL} from '../SubComponent/Models/Models';
import { base64ToBlob } from '../../../utils/Base64ToBlob';

/**

 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param model photoPickerFile: component model
 * @param useState setPhotoPickerFile: state to update the component
 */
const CustomMultipleApp =  ({photoPickerFile, setPhotoPickerFile}) => {

    /**
     * Function to add the photo taken from the camera to the file list in the model
     */
    const handleAddFile = () => {
        const imageSrc = photoPickerFile?.selfieSrc;
        const mimeType = "image/jpeg";
        if(imageSrc){
            const imageBlob = base64ToBlob(imageSrc, mimeType);
            let date = "" + moment().format("DDMMYYYYHHMMSS");
            const imageFile = new File([imageBlob], `selfie_${date}.jpeg`, { type: mimeType });
            const newItem = {
                ...PHOTO_PICKER_MODEL,
                fileSelected: imageFile
            };
            setPhotoPickerFile(prev => ({
                ...prev,
                selfieSrc: null,
                listFiles: [...prev.listFiles, newItem]
            }));
        }
    }

    /**
     * Indicates whether the file taken with the camera has already been added
     */
    const isFileAdditionDone = () => {
        return photoPickerFile?.selfieSrc == null
    }

    return {
        handleAddFile,
        isFileAdditionDone
    }

}

export default CustomMultipleApp;


